module.exports = __webpack_public_path__ + "img/visu-stockage@2x.523fd542.jpg";